import axios from 'axios';
import { BASE_URL } from '../utils/helpers';
import { toast } from 'react-toastify';

const axiosClient = axios.create({
    baseURL: `${BASE_URL}/api`,
    headers: {
        'Content-Type': 'application/json',
    },
});

// 1. Tự động gắn Token vào mọi request gửi đi
axiosClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

let isAlreadyRedirecting = false;
let isNetworkErrorShowing = false; // Biến cờ chống spam lỗi mạng

// 2. BẮT LỖI TRẢ VỀ TỪ BACKEND
axiosClient.interceptors.response.use(
    (response) => {
        // Trả về dữ liệu trực tiếp nếu có
        return response.data || response;
    },
    (error) => {
        // 👉 KIỂM TRA LỖI MẠNG (Server sập / Mất mạng)
        if (!error.response) {
            if (!isNetworkErrorShowing) {
                isNetworkErrorShowing = true;
                toast.error("Không thể kết nối đến máy chủ. Vui lòng kiểm tra lại mạng hoặc thử lại sau!");
                setTimeout(() => { isNetworkErrorShowing = false; }, 5000); // 5s sau mới cho hiện lại
            }
            return Promise.reject(error);
        }

        const { response } = error;

        if (response) {
            // Trường hợp 401: Token hết hạn hoặc không hợp lệ
            if (response.status === 401) {
                if (!isAlreadyRedirecting) {
                    isAlreadyRedirecting = true;
                    
                    toast.warn("Phiên đăng nhập đã hết hạn. Bạn đã được chuyển về trang chủ.");
                    
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('user_info');

                    // Delay một chút để người dùng đọc thông báo
                    setTimeout(() => {
                        // ĐIỀU CHỈNH: Chuyển về trang chủ
                        if (window.location.pathname !== '/') {
                            window.location.href = '/';
                        } else {
                            // Đang ở sẵn trang chủ thì load lại trang để xóa cache giao diện cũ
                            window.location.reload();
                        }
                    }, 1500);
                }
            }

            // Trường hợp 403: Có đăng nhập nhưng không đủ quyền
            if (response.status === 403) {
                if (!isAlreadyRedirecting) {
                    // Logic của bạn: Nếu bị 403 do JWT thì đẩy ra
                    // Kiểm tra URL hiện tại để quyết định xử lý
                    if (window.location.pathname.startsWith('/admin')) {
                        // Nếu đang ở trang Admin mà bị 403, có thể là do role không đúng
                        toast.error("Bạn không có quyền truy cập trang quản trị!");
                        isAlreadyRedirecting = true;
                        setTimeout(() => { window.location.href = '/'; }, 1500);
                    } else {
                        isAlreadyRedirecting = true;
                        toast.warn("Phiên đăng nhập không hợp lệ. Bạn đã được chuyển về trang chủ.");
                        localStorage.removeItem('access_token');
                        localStorage.removeItem('user_info');
                        setTimeout(() => { 
                            if (window.location.pathname !== '/') {
                                window.location.href = '/';
                            } else {
                                window.location.reload();
                            }
                        }, 1500);
                    }
                }
            }
        }

        return Promise.reject(error);
    }
);

export default axiosClient;